module.exports = __webpack_public_path__ + "img/ic_spin.6c5b2d1f.svg";